import { useEffect } from "react";
import { useDomainBranding } from "@/hooks/useDomainBranding";
import { useCopyrightContent } from "@/hooks/useCopyrightContent";

// Actualiza en vivo el favicon, el apple-touch-icon (ícono de home screen iOS),
// el mask-icon y el nombre de la PWA a partir del branding resuelto para el
// dominio actual. Así, cuando el admin sube un logo global (o un tenant su
// logo de franquicia/SaaS), el ícono del navegador y de la app instalada se
// actualizan sin reescribir index.html. Las etiquetas estáticas de index.html
// siguen como fallback inicial.
const DEFAULT_LOGO = "https://media.base44.com/images/public/6aa6211001d513cafb0a3a5c/8b0969465_BHGC.png";

export default function AppIconInjector() {
  const branding = useDomainBranding();
  const { content } = useCopyrightContent();
  const logo = branding?.logo_url || DEFAULT_LOGO;
  // Nombre completo de la marca (marca + subtítulo), igual que el `name` del
  // manifest y el <title>: así application-name coincide con el nombre que
  // Google compara contra la pantalla de consentimiento OAuth.
  const appName = branding?.brand_name
    ? `${branding.brand_name} ${branding.tagline || ""}`.trim()
    : (content?.title || "BHGC Nexus Logistics");

  useEffect(() => {
    const setLink = (rel, sizes) => {
      const sel = `link[rel="${rel}"]` + (sizes ? `[sizes="${sizes}"]` : "");
      let link = document.querySelector(sel);
      if (!link) {
        link = document.createElement("link");
        link.rel = rel;
        if (sizes) link.setAttribute("sizes", sizes);
        document.head.appendChild(link);
      }
      link.setAttribute("href", logo);
    };
    setLink("icon", "192x192");
    setLink("icon", "512x512");
    setLink("apple-touch-icon");
    setLink("mask-icon");
    const appMeta = document.querySelector('meta[name="application-name"]');
    if (appMeta) appMeta.setAttribute("content", appName);
    const touchMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (touchMeta) touchMeta.setAttribute("content", appName);
  }, [logo, appName]);

  return null;
}